export default __webpack_public_path__ + "static/media/tel_icon.df900ee8.png";